"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./Pagination.style"));

var Icon_1 = tslib_1.__importDefault(require("../Icon"));

var PaginationItem_1 = tslib_1.__importDefault(require("./PaginationItem"));

function Pagination(_ref) {
  var className = _ref.className,
      page = _ref.page,
      totalPage = _ref.totalPage,
      _ref$showCount = _ref.showCount,
      showCount = _ref$showCount === void 0 ? 5 : _ref$showCount,
      onChange = _ref.onChange;
  var leftIconName = page <= 1 ? 'ic_arrow_left_sm_gray_300' : 'ic_arrowleft_sm_blue_500';
  var rightIconName = page >= totalPage ? 'ic_arrow_right_md_gray_300' : 'ic_arrowright_sm_blue_500';
  var maxPageChunk = Math.floor((totalPage - 1) / showCount);
  var pageChunk = Math.floor((page - 1) / showCount);
  var pageCount = totalPage > showCount ? showCount : totalPage;

  if (pageChunk === maxPageChunk) {
    pageCount = (totalPage - 1) % showCount + 1;
  }

  var pages = Array(pageCount).fill(0); // Display 되는 페이지 중 시작점(1부터 시작하므로 1을 빼주고 최종적으로 1을 더해줌)

  var startPage = Math.floor((page - 1) / showCount) * showCount + 1;

  for (var i = 0; i < pageCount; i += 1) {
    pages[i] = startPage + i;
  }

  var handlePageNumberClick = react_1.useCallback(function (draftValue) {
    onChange && onChange(draftValue);
  }, [onChange]);

  function handleArrowClicked(direction) {
    var isLeftArrow = direction === 'left';
    var newPage = page;

    if (isLeftArrow && page > 1) {
      newPage -= 1;
    } else if (!isLeftArrow && page < totalPage) {
      newPage += 1;
    }

    onChange && onChange(newPage);
  }

  return jsx_runtime_1.jsx("div", Object.assign({
    className: className,
    css: styles.root
  }, {
    children: jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.container
    }, {
      children: [jsx_runtime_1.jsx(PaginationItem_1.default, Object.assign({
        onClick: function onClick() {
          handleArrowClicked('left');
        },
        isArrow: true
      }, {
        children: jsx_runtime_1.jsx(Icon_1.default, {
          name: leftIconName
        }, void 0)
      }), void 0), pages.map(function (pageNumber) {
        return jsx_runtime_1.jsx(PaginationItem_1.default, Object.assign({
          pageNumber: pageNumber,
          active: pageNumber === page,
          onClick: handlePageNumberClick
        }, {
          children: pageNumber
        }), pageNumber);
      }), jsx_runtime_1.jsx(PaginationItem_1.default, Object.assign({
        onClick: function onClick() {
          handleArrowClicked('right');
        },
        isArrow: true
      }, {
        children: jsx_runtime_1.jsx(Icon_1.default, {
          name: rightIconName
        }, void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
}

exports.default = Pagination;